module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/tag-alt-52a07fe6638fef3a049bace255b060cd.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/tag-alt.svg
// module id = 1N3O
// module chunks = 24